
/* injects from baggage-loader */

CKEDITOR.plugins.add( 'blocksettings', {
  requires: 'panelbutton',
  init: function( editor ) {
    var allowed = 'a[!href]',
      required = 'a[href]',
      plugin = CKEDITOR.plugins.link;

    if ( CKEDITOR.dialog.isTabEnabled( editor, 'link', 'advanced' ) )
      allowed = allowed.replace( ']', ',accesskey,charset,dir,id,lang,name,rel,tabindex,title,type]{*}(*)' );
    if ( CKEDITOR.dialog.isTabEnabled( editor, 'link', 'target' ) )
      allowed = allowed.replace( ']', ',target,onclick]' );

    function getCompiledProtectionFunction( editor ) {
      var emailProtection = editor.config.emailProtection || '',
        compiledProtectionFunction;

      // Compile the protection function pattern.
      if ( emailProtection && emailProtection != 'encode' ) {
        compiledProtectionFunction = {};

        emailProtection.replace( /^([^(]+)\(([^)]+)\)$/, function( match, funcName, params ) {
          compiledProtectionFunction.name = funcName;
          compiledProtectionFunction.params = [];
          params.replace( /[^,\s]+/g, function( param ) {
            compiledProtectionFunction.params.push( param );
          } );
        } );
      }

      return compiledProtectionFunction;
    }
    this.compiledProtectionFunction = getCompiledProtectionFunction( editor );

    editor.ui.add( 'blocksettings', CKEDITOR.UI_PANELBUTTON, {
      label: 'blocksettings',
      className: 'cke_blocksettings',
      title: 'blocksettings',
      modes: { wysiwyg: 1 },
      editorFocus: 1,
      toolbar: 'blocksettings,' + 10,
      allowedContent: allowed,
      requiredContent: required,
      panel: {
        css: CKEDITOR.skin.getPath( 'editor' ),
        attributes: { role: 'listbox', 'aria-label': 'lang.panelTitle' }
      },
      onBlock: function(panel, block) {

      },
      onOpen: function(){
        $(".e__tools").scope().editorNavOpenWidget = true
        $(".e__tools").scope().$apply()
      },
      onClose: function(){

      }
    });
  },

  afterInit: function( editor ) {

  }
} );




// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/wysiwyg/ckeditor/plugins/blocksettings/plugin.js